import {getSearchListData, getSearchListCount, getSubSearchList, getCvWorkflowProcedure, getCvProcessParamValue, getCvProcessDatabase, getCvProcessTheoreticallyDigestionLib, saveProcess, getProcessInfo, makeSureComputed, checkIfExperimentCanBeUsedToBatchInnovationProcess, resumeComputed, pauseComputed, terminateComputed, getStats, removeComputed} from 'api/search'
const search = {
  state: {
    localMascotBaseName: {
      lgSpeciesName: '',
      label: '',
      id: ''
    }
  },
  mutations: {
    SET_BASENAME (state, name) {
      state.localMascotBaseName = name
    }
  },
  actions: {
    setBaseName ({commit}, data) {
      commit('SET_BASENAME', data)
    },
    getSearchListData ({commit}, data) {
      return new Promise((resolve, reject) => {
        getSearchListData(data).then((res) => {
          resolve(res.result.list)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getSearchListCount ({commit}, data) {
      return new Promise((resolve, reject) => {
        getSearchListCount(data).then((res) => {
          resolve(res.result.total)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getSubSearchList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getSubSearchList(data).then((res) => {
          resolve(res.result.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCvWorkflowProcedure ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvWorkflowProcedure(data).then((res) => {
          resolve(res.result.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCvProcessParamValue ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvProcessParamValue(data).then((res) => {
          resolve(res.result.data)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCvProcessDatabase ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvProcessDatabase(data).then((res) => {
          resolve(res.result.data)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getCvProcessTheoreticallyDigestionLib ({commit}, data) {
      return new Promise((resolve, reject) => {
        getCvProcessTheoreticallyDigestionLib(data).then((res) => {
          resolve(res.result.data)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getProcessInfo ({commit}, data) {
      return new Promise((resolve, reject) => {
        getProcessInfo(data).then((res) => {
          resolve(res.result.result)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    saveProcess ({commit}, data) {
      return new Promise((resolve, reject) => {
        saveProcess(data).then((res) => {
          resolve(res.result.processCodeList)
        }).catch(error => {
          reject(error)
        })
      })
    },
    makeSureComputed ({commit}, data) {
      return new Promise((resolve, reject) => {
        makeSureComputed(data).then((res) => {
          resolve(res.result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    resumeComputed ({commit}, data) {
      return new Promise((resolve, reject) => {
        resumeComputed(data).then((res) => {
          resolve(res.result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    pauseComputed ({commit}, data) {
      return new Promise((resolve, reject) => {
        pauseComputed(data).then((res) => {
          resolve(res.result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    getStats ({commit}, data) {
      return new Promise((resolve, reject) => {
        getStats(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    terminateComputed ({commit}, data) {
      return new Promise((resolve, reject) => {
        terminateComputed(data).then((res) => {
          resolve(res.result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    removeComputed ({commit}, data) {
      return new Promise((resolve, reject) => {
        removeComputed(data).then((res) => {
          resolve(res.result.data)
        }).catch(error => {
          reject(error)
          console.log(error)
        })
      })
    },
    checkIfExperimentCanBeUsedToBatchInnovationProcess ({commit}, data) {
      return new Promise((resolve, reject) => {
        checkIfExperimentCanBeUsedToBatchInnovationProcess(data).then((res) => {
          resolve(res.result)
        }).catch(error => {
          console.log(error)
        })
      })
    }
  }
}

export default search



// WEBPACK FOOTER //
// ./src/store/modules/search.js